import { Component } from '@angular/core'
import { ButtonWidget } from 'ngx-schema-form'

@Component({
  selector: 'app-button-widget',
  templateUrl: './button-widget.component.html',
  styleUrls: ['./button-widget.component.scss'],
})
export class ButtonWidgetComponent extends ButtonWidget {}
